import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {  ViewChild } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {MaterialModule} from '../../material.module';
import {Sort, MatTabChangeEvent} from '@angular/material';
import * as Clipboard from 'clipboard';
import * as Moment from "../../../../node_modules/moment/moment.js"
declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes, Router} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsTrafalgarComponent implements OnInit {

    meetingrooms:MeetingRooms[];
    modified_meetingrooms:MeetingRooms[];
    startenddates:StartEndDates[];
    timearray:TimeArray[];
    images_array:Images_array[];
    workgroups:WorkGroups[];
    calendar: Date;
    public attendantsarray:string[] = [];
      years: number[] = [];
    public RoomURL:string;
    public currently_selected_room;
    public ip = location.host;
    public submitted:boolean;
    public clipboard = new Clipboard('.btn');

    archived_events=[];
    upcoming_events=[];

    eventstable;
    pageLength:number;
    pageSize = 50;
    pageIndex=0;

    user:Object;
    sortedData;
    panelOpenState = false;


      constructor(private authService:AuthenticationService ,private router:Router , private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {

      }

      sortUpcomingEvents(sort: Sort) {

        const data = this.upcoming_events;

        if (!sort.active || sort.direction == '') {
          this.sortedData = data;
          return;
        }

        this.sortedData = data.sort((a, b) => {
          let isAsc = sort.direction == 'asc';
          var event_start_int_a = a.event_start_time;
          var event_start_int_b = b.event_start_time;
          switch (sort.active) {

            case 'timefrom': return compare(event_start_int_a, event_start_int_b, isAsc);
            default: return 0;
          }
        });
        function compare(a, b, isAsc) {
          return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        }
      }

      tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
        // //console.log('tabChangeEvent => ', tabChangeEvent); 
        // //console.log('index => ', tabChangeEvent.index); 
        this.refreshEverything(this.timearray);
        this.panelOpenState = false
        if(tabChangeEvent.index ==1){
          //////////////////for filter/////////////////////////////
          $('.date-inputs-start-filter').datetimepicker({
            step:30,
            format: 'MM/DD/YYYY h:mm A',
            formatTime: 'h:mm A',
            formatDate:'MM/DD/YYYY',
            onChangeDateTime:(ct,$i)=>{
                $('.date-inputs-end-filter').datetimepicker({
                  value:$('.date-inputs-start-filter').val()
                  
                });


            }
           
          });

          $('.date-inputs-end-filter').datetimepicker({
          step:30,    
          format: 'MM/DD/YYYY h:mm A',
          formatTime: 'h:mm A',
          formatDate:'MM/DD/YYYY',
          onSelectTime:(ct,$i)=>{


          }
          });
        }
    }
      sortArchivedEvents(sort: Sort) {

        const data = this.archived_events;

        if (!sort.active || sort.direction == '') {
          this.sortedData = data;
          return;
        }

        this.sortedData = data.sort((a, b) => {
          let isAsc = sort.direction == 'asc';
          var event_start_int_a = a.event_start_time;
          var event_start_int_b = b.event_start_time;
          switch (sort.active) {

            case 'timefrom': return compare(event_start_int_a, event_start_int_b, isAsc);
            default: return 0;
          }
        });
        function compare(a, b, isAsc) {
          return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        }
      }

      applyfilter(){

        this.currently_selected_room=$('#room_name').find(":selected").text();
        this.getdataService.getStartEndDatesForCurrentRoomURL(`/fetchs/fetch_event_dates_forcurrentroom/`+$('#room_name').val()).subscribe((startenddates) => {
        this.pageLength = startenddates.length;

        
        //this.eventstable = startenddates.slice(this.pageIndex *this.pageSize,(this.pageIndex *this.pageSize)+this.pageSize);
        this.startenddates=  startenddates
        for(var i=0; i<this.startenddates.length; i++)
        {
            if(startenddates[i].event_logo_path =='' && startenddates[i].event_room_id == $('#room_name').val() )
            {

              this.startenddates[i].event_logo_path = this.getCurrentMeetingRoomLogo(this.currently_selected_room);

            }else{

            }
        }
        this.upcoming_events= [];
        this.archived_events=[];
        var current_date = new Date();
        //here we will distinguish archive from upcoming two variables up
          for(var i=0; i<this.startenddates.length; i++)
          {
            
            // //console.log(Moment(startenddates[i].event_start_time).valueOf())
            // //console.log(current_date.getTime())
            
              // if(Moment(startenddates[i].event_end_time).valueOf() +86400000 >= current_date.getTime() )
              // {
              //   this.upcoming_events.push(startenddates[i]);

              // }else{
              // }
                if(Moment(startenddates[i].event_start_time).valueOf() > Moment($('.date-inputs-start-filter').val()).valueOf() && Moment(startenddates[i].event_end_time).valueOf() < Moment($('.date-inputs-end-filter').val()).valueOf()){
                //  //console.log(startenddates[i])
                  this.archived_events.push(startenddates[i]);
                }
 
            
          }
          for(var i=0; i<this.startenddates.length; i++)
          {
                this.startenddates[i].event_start_time_readable = new Date(this.startenddates[i].event_start_time).toLocaleString("en-US", {  timeZone: 'UTC' });
  
                this.startenddates[i].event_end_time_readable = new Date(this.startenddates[i].event_end_time).toLocaleString("en-US", {  timeZone: 'UTC' });
  
  
            }
            $('.date-inputs-start-filter').val("")
            $('.date-inputs-end-filter').val("")
        }
          ,
        err=>{

          return false;
        });
      }

  ngOnInit() {

     this.submitted=true;
     let d = new Date();
     let month = d.getMonth();
     let day = d.getDate();
     let year = d.getFullYear();
     let hour = d.getHours();
     let mins = d.getMinutes();
        $(document).ready(function(){ $('ul.tabs').tabs(); });
        $(document).ready(function(){
      $('.modal').modal();
    });
    this.timearray = [

     ];



       $('#calendar').hide();
      $('#calendar').fullCalendar({
        header: {
          center: 'agendaDay,settimana'
        
       },
       selectable: true,
       select: (startDate, endDate)=> {
         
       this.showCalendar();

        $('.date-inputs-start').datetimepicker({
          value:this.convertUTCDateToLocalDate(new Date(startDate))
        });
        $('.date-inputs-end').datetimepicker({
          value:this.convertUTCDateToLocalDate(new Date(endDate))
        });

        },
        eventClick: (calEvent, jsEvent, view) => {

          this._flashMessagesService.show('Editing Event:'+calEvent.title, {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

          this.router.navigate(['/admin/edittrafalgarevents/', calEvent.id]);
        
      
       },
       contentHeight: 450,
       allDaySlot: false,

       disableDragging: true,
       
       views: {
        settimana: {
           type: 'agendaWeek',
           duration: {
               days: 7
           },
           title: 'Apertura'

           },
           agendaDay: {
    
          }
     },
       defaultView: 'settimana',
         events: this.timearray
      })

      $.datetimepicker.setDateFormatter({
        parseDate: function (date, format) {
          var d = Moment(date, format);
              return d.isValid() ? d.toDate() : false;
          },
          
          formatDate: function (date, format) {
              return Moment(date).format(format);
          }
      })
      
      $('.date-inputs-start').val(new Date(year, month, day, hour, mins));
      $('.selection_panel').hide();
      $('.date-inputs-start').datetimepicker({
          step:30,
          format: 'MM/DD/YYYY h:mm A',
          formatTime: 'h:mm A',
          formatDate:'MM/DD/YYYY',
          onSelectTime:(ct,$i)=>{
              $('.date-inputs-end').datetimepicker({
                value:$('.date-inputs-start').val()
                
              });


          }
      });
      
      $('.date-inputs-end').datetimepicker({
        step:30,    
        format: 'MM/DD/YYYY h:mm A',
        formatTime: 'h:mm A',
        formatDate:'MM/DD/YYYY',
        onSelectTime:(ct,$i)=>{


        }
      });

     


      $('#room_name').change( ()=> {
          if(  $('#calendar').is(':visible')){

          }else{
            $('.selection_panel').show();
          }
        this.refreshEverything(this.timearray);


        });


      ////////refresh category /////////////
      this.authService.getProfile().subscribe((user) => {
        this.submitted=true;
        this.user=  user;

        if(this.user[0].user.isAdmin)
        {
            this.getdataService.getMeetingRoomsByAccount(this.user[0].user.account_ID).subscribe((meetingrooms) => {
              this.modified_meetingrooms=  meetingrooms;

               this.submitted=false;
            },
          err=>{
    
            return false;
          });
        }else{
          this.getdataService.getMeetingRoomsByAccount(this.user[0].user.account_ID).subscribe((meetingrooms) => {
            this.meetingrooms=  meetingrooms;
          
            this.getdataService.getWorkGroupsByWorkgroupID(this.user[0].user.workgroupID).subscribe((workgroups) => {
                this.workgroups=  workgroups;
          
                let meetingsObject=[];
                let y=0;
                for(let i=0; i<this.workgroups[0].roomID_Array.length; i++)
                {
        

                  for(let x=0; x<this.meetingrooms.length; x++)
                  {
                    if(this.workgroups[0].roomID_Array[i].roomID == this.meetingrooms[x]._id)
                    {
      
                        meetingsObject[y]  = this.meetingrooms[x];
                        y++;
                    }
                  }

                }
  
                this.modified_meetingrooms =meetingsObject;

                 this.submitted=false;
              },
            err=>{
          
              return false;
            });
             this.submitted=false;
          },
        err=>{
    
          return false;
        });

        }

      },
    err=>{

      return false;
    });
    ////////////authenticate user////////////////////////
  }

      public checkifTimeispassed(date:Date): boolean{
        var dateNow = new Date();
        date = new Date(date);

        var dateNumNow = dateNow.getTime();
          var dateNum = date.getTime();
 
        if(dateNumNow<=dateNum)
        {

          return true;
        }else{
          $(window).scrollTop(0);
          return false;
        }

    }

    public convertUTCDateToLocalDate(date):Date {

      var newDate = new Date(date.getTime()+(date.getTimezoneOffset()*60*1000));

      return newDate;
    }

    public checkIfEndisbiggerthanStart(dateEnd:Date,dateStart:Date): boolean{

      dateEnd = new Date(dateEnd);
      dateStart = new Date(dateStart);

      var dateNumEnd = dateEnd.getTime();
      var dateNumStart = dateStart.getTime();

      if(dateNumEnd>=dateNumStart)
      {

        return false;
      }else{
          $(window).scrollTop(0);
        return true;
      }

  }

    public checkTimeAvailablility(date:Date): boolean{
    if(this.startenddates.length>0)
    {
      for (var i=0; i <this.startenddates.length; i++) {

          date = new Date(date);

          var dateNum = date.getTime();

          var event_start_time = new Date(this.startenddates[i].event_start_time);
          var event_end_time = new Date(this.startenddates[i].event_end_time);
          var event_start_time_int = event_start_time.getTime();
          var event_start_time_int = event_start_time_int + ((new Date(this.startenddates[i].event_start_time).getTimezoneOffset())*60*1000);
          var event_end_time_int = event_end_time.getTime();
          var event_end_time_int = event_end_time_int + ((new Date(this.startenddates[i].event_end_time).getTimezoneOffset())*60*1000);

          if(dateNum>=event_start_time_int && dateNum<event_end_time_int  )
          {
            $(window).scrollTop(0);
            return false;
          }



        }
        return true;
    }else{
      return true;
    }

  }


      deleteEvent = function(deletedEventID,deletedEventName,EventLogo) {
             if(confirm('Are you sure you want to delete event "'+deletedEventName+'"?')) {
             this.submitted=true;
             for(var i=0; i<this.startenddates.length; i++)
             {
                if(this.startenddates[i]._id == deletedEventID){
                  if(this.startenddates[i].using_default_logo == 'false')
                  {
                  
                  }else{
                  
                    EventLogo='z';
                  }
                }
             }

             this.deletedataService.deleteEvent(deletedEventID,deletedEventName,EventLogo).subscribe((res:Response)=>{

                   ////////refresh category /////////////
                   this.refreshEverything(this.timearray);
                 //////////end refresh category.////////
                  this.submitted=false;
           });
        }
      }
  public showCalendar(): void{

        if(  $('#calendar').is(':visible')){
            $('#calendar').hide();
            if(this.currently_selected_room!=null)
            {
              $('.selection_panel').show();
            }
            $('#calendar').fullCalendar('rerenderEvents');

        }else{

          $('.selection_panel').hide();
            $('#calendar').show();
              $('#calendar').fullCalendar('rerenderEvents');

        }

      }

      refreshThings = function() {

                  $('#calendar').fullCalendar( 'rerenderEvents' );

      }


    refreshEverything = (TimeArray)=>{
        this.currently_selected_room=$('#room_name').find(":selected").text();
        this.getdataService.getStartEndDatesForCurrentRoomURL(`/fetchs/fetch_event_dates_forcurrentroom/`+$('#room_name').val()).subscribe((startenddates) => {
        this.pageLength = startenddates.length;

        
        //this.eventstable = startenddates.slice(this.pageIndex *this.pageSize,(this.pageIndex *this.pageSize)+this.pageSize);
        this.startenddates=  startenddates
        for(var i=0; i<this.startenddates.length; i++)
        {
            if(startenddates[i].event_logo_path =='' && startenddates[i].event_room_id == $('#room_name').val() )
            {

              this.startenddates[i].event_logo_path = this.getCurrentMeetingRoomLogo(this.currently_selected_room);

            }else{

            }
        }
        this.upcoming_events= [];
        this.archived_events=[];
        var current_date = new Date();
        //here we will distinguish archive from upcoming two variables up
        for(var i=0; i<this.startenddates.length; i++)
        {
          
          // //console.log(Moment(startenddates[i].event_start_time).valueOf())
          // //console.log(current_date.getTime())
          
            if(Moment(startenddates[i].event_end_time).valueOf() +86400000 >= current_date.getTime() )
            {

              this.upcoming_events.push(startenddates[i]);
            }else{
              this.archived_events.push(startenddates[i]);
            }
        }

        for(var i=0; i<this.modified_meetingrooms.length;i++)
        {
          if(this.modified_meetingrooms[i]._id == $('#room_name').val() )
          {
            this.RoomURL = this.modified_meetingrooms[i]._id.toString();
          }
        }



        TimeArray=[];
        //calendar
        for(var i=0; i<this.startenddates.length; i++)
        {
              this.startenddates[i].event_start_time_readable = new Date(this.startenddates[i].event_start_time).toLocaleString("en-US", {  timeZone: 'UTC' });

              this.startenddates[i].event_end_time_readable = new Date(this.startenddates[i].event_end_time).toLocaleString("en-US", {  timeZone: 'UTC' });

              TimeArray.push(
                {
                  id:this.startenddates[i]._id,
                  title:this.startenddates[i].event_name,
                  start:this.startenddates[i].event_start_time_readable,
                  end:this.startenddates[i].event_end_time_readable
                }
              )

              //////console.log(TimeArray[i]);
          }
        $('#calendar').fullCalendar('removeEvents');
        $('#calendar').fullCalendar( 'addEventSource', TimeArray );


        }
          ,
        err=>{

          return false;
        });

      }

    public  getCurrentMeetingRoomLogo(MeetingRoom): string {
          var meeting_room_default_logo;
          for(var i=0; i<this.modified_meetingrooms.length; i++ )
          {
              if(this.modified_meetingrooms[i].room_name == MeetingRoom)
              {
              meeting_room_default_logo =   this.modified_meetingrooms[i].room_default_logo_path;
              }
          }

          return meeting_room_default_logo;
      }

      public addAttendant():void{
        let eventattendant = this.elem.nativeElement.querySelector('#event_attendant').value;
        $('#event_attendant').val('');
        this.attendantsarray.push(eventattendant);

      }

      public deleteAttendant(attendant):void{

        for(let i=0; i<this.attendantsarray.length; i++)
        {
          if(this.attendantsarray[i] == attendant)
          {
             this.attendantsarray.splice(i, 1);
          }
        }

      }

      pageEvent(ev){
        ////console.log(ev);
        const pageIndex = ev.pageIndex;
        this.pageIndex = pageIndex;
        const pageSize = ev.pageSize;
        this.pageSize = pageSize;
        const skip = pageIndex * pageSize;

        this.eventstable = this.startenddates.slice(skip,skip+pageSize);
  
      }
    
    public addEvent(): void{
      this.submitted=true;
      let files = this.elem.nativeElement.querySelector('#image').files;
      let room_name = this.currently_selected_room;
      let eventname = this.elem.nativeElement.querySelector('#eventname').value;
      let event_host = this.elem.nativeElement.querySelector('#event_host').value;
      let start_date = this.elem.nativeElement.querySelector('#start_date').value;
      let end_date = this.elem.nativeElement.querySelector('#end_date').value;
      let event_attendants_array = this.attendantsarray;

      start_date = new Date(start_date).getTime() - ((new Date(start_date).getTimezoneOffset())*60*1000);
      start_date = new Date(start_date);

      end_date = new Date(end_date).getTime() - ((new Date(end_date).getTimezoneOffset())*60*1000);
      end_date = new Date(end_date);
 
      let formData = new FormData();

      //check if attendantes are only one or what?
      if(event_attendants_array.length>0)
      {

        if(event_attendants_array.length>1)
        {
          formData.append('one','notone');
          for(let i=0; i<event_attendants_array.length;i++)
          {
            formData.append('event_attendants',event_attendants_array[i]);
          }
        }else{
          formData.append('one','one');
          let event_attendants_array  = JSON.parse(JSON.stringify(this.attendantsarray[0]));
          formData.append('event_attendants',event_attendants_array);
        }
      }



      let file = files[0];

      formData.append('event_room',room_name);
      formData.append('event_room_id',$('#room_name').val());
      formData.append('event_name',eventname);
      formData.append('event_host_name',event_host);
      formData.append('start_date',start_date);
      formData.append('end_date',end_date);
      formData.append('account_id',this.user[0].user.account_ID);


      if(typeof file ==='undefined')
      {
        formData.append('image','');
        formData.append('using_default_logo','true');
        this.adddataService.addEvent(formData).subscribe
        (res =>{
              this._flashMessagesService.show('Success: Event added successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

              ////////refresh category /////////////
             this.refreshEverything(this.timearray);
            $('#formNewEvent')[0].reset();
            //////////end refresh category.////////
            this.submitted=false;
          } );
      }else{

        formData.append('image',file,file.name);
        formData.append('using_default_logo','false');
        if(file.size < 10096865)
        {
          this.adddataService.addEvent(formData).subscribe
          (res =>{
                this._flashMessagesService.show('Success: Event added successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

                ////////refresh category /////////////
               this.refreshEverything(this.timearray);
              $('#formNewEvent')[0].reset();
              //////////end refresh category.////////
              this.submitted=false;
        } );

        }else{
         $(window).scrollTop(0);
          this._flashMessagesService.show('Error: File size is over limit, maximum file size is 5mb', {cssClass: 'center-align flow-text card-title z-depth-2 white-text red darken-1', timeout:5000});
          this.submitted=false;
        }
      }

      //empty attendants array
      this.attendantsarray = [];




    }
}



interface MeetingRooms{
  _id:string,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}

interface StartEndDates{
  _id:number,
  event_name:string,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  using_default_logo:string,
  event_host_name:string
}

interface TimeArray{
  title:string,
  start:string,
  end:string
}

interface Images_array{
  image_url:string
}


interface WorkGroups{
  _id:string,
  account_ID:string,
  workgroup_name:string,
  roomID_Array:[{
    roomID: string
  }]
}




// WEBPACK FOOTER //
// ./src/app/components/events_trafalgar/events.component.ts